"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { getImageURL, useSwiperSliderOptions } from "@/lib";
import { Autoplay } from "swiper/modules";

export const HomePageTrustedClientSection = ({
    data = {},
    slug = "home_trusted_client",
}) => {
    const { icon_slider = [] } = data;

    const { options } = useSwiperSliderOptions({
        modules: [Autoplay],
        freeMode: true,
        speed: 2000,
        slidesPerView: "1",
        loop: true,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            240: {
                slidesPerView: 2.1,
            },
            600: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 5,
            },
            1200: {
                slidesPerView: 8,
            },
        },
    });

    if (!Array.isArray(icon_slider) || icon_slider.length === 0) {
        return null;
    }

    return (
        <>
            <section
                className="trusted__section client_slider_sec indo__client_section overflow-hidden"
                id={slug}
            >
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <div className="indoclient__slider">
                                    <Swiper {...options}>
                                        {icon_slider?.map((item, idx) => {
                                            const icon = item?.icon;
                                            if (!icon?.src) return null;
                                            return (
                                                <SwiperSlide key={idx}>
                                                    <div className="client_logo_inr">
                                                        <img
                                                            className="img-fluid"
                                                            src={getImageURL(
                                                                icon.src
                                                            )}
                                                            alt={icon.alt || ""}
                                                        />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
